import { FC, memo, PropsWithChildren } from "react";
import "./panel-title.scss";

interface PanelTitlerops extends PropsWithChildren {
  className?: string;
}
const PanelTitleComponent: FC<PanelTitlerops> = ({ className = "", children }) => {
  return <h3 className={`panel-title text-black ${className}`}>{children}</h3>;
};

export const PanelTitle = memo(PanelTitleComponent);
